export const logo = {
  label: 'Logo',
  name: 'logo',
  component: 'group',
  description: 'Logo',
  fields: [
    {
      label: 'Logo',
      name: 'logo',
      component: 'image',
      description: 'Recommended image size: 140 x 32px',
    },
    {
      label: 'Logo Alt',
      name: 'logoAlt',
      component: 'text',
      description: 'Brief description of image',
    },
  ],
};
